import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsArray, IsNumber, IsString, ValidateNested } from "class-validator";

export class DocumentToPrintResponseItem {
  @Expose()
  @IsString()
  id!: string;
  @Expose()
  @IsString()
  contractorName!: string;
  @Expose()
  @IsString()
  documentNumber!: string;
  @Expose()
  @IsNumber()
  copyCount!: number;
}

export class DocumentToPrintResponse extends GenericTableResponse<DocumentToPrintResponse> {
  @Expose()
  @Type(() => DocumentToPrintResponseItem)
  @ValidateNested()
  @IsArray()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<DocumentToPrintResponseItem>;
}
